import { memo } from 'react';

type Props = {
  fieldName: string;
  filesCount?: number;
  errorsCount?: number;
};

export const Label = memo(
  ({ fieldName, filesCount = 0, errorsCount = 0 }: Props) => (
    <div className="mb-4 ml-auto inline-flex w-1/10 justify-end">
      <div className="flex text-xs">
        {errorsCount > 0 && (
          <span className="inline-flex pr-2.5 text-destructive">
            <span data-cy={`file-${fieldName}-error-count`}>
              {String(errorsCount)}
            </span>
            <span className="pl-1"> error{errorsCount > 1 && 's'}</span>
          </span>
        )}
        <span className="inline-flex w-full text-primary">
          <span data-cy={`file-${fieldName}-file-count`}>
            {String(filesCount)}
          </span>
          <span className="pl-1">{filesCount !== 1 ? 'files' : 'file'}</span>
        </span>
      </div>
    </div>
  )
);
